<template>
  <div class="service">
    <h3 v-text="item.title"></h3>
    <ul>
      <li v-for="(listItem, i) in item.items" :key="i" v-text="listItem"></li>
    </ul>
    <router-link to="works" class="btn btn--white">عرض جميع الأعمال</router-link>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
.service {
  position: relative;
  z-index: 2;
  // opacity: 0;
  // pointer-events: none;
  // transform: translateY(15%);
  // transition: 1s cubic-bezier(.43,.26,.13,1.01);

  width: 50%;

  @media screen and (min-width: 960px) {
    margin-top: 0;
    width: 33.33%;
  }

  @media screen and (min-width: 1440px) {
    margin-top: 0;
  }

  ul {
    margin-block-start: 1rem;
    margin-block-end: 1rem;
  }
}

</style>
